// @flow
import React from 'react';
import StatusHub from '../../components/StatusHub/StatusHub';

const ErrorContainer = (props) => {
    const { match, urlParam } = props;

    return (
        <StatusHub error urlParam={urlParam} redirect={match.params.redirect} />
    );
}

export default ErrorContainer;
